import React from 'react'
import { Column, Summary, TotalItem, GroupItem } from 'devextreme-react/data-grid'
import { NumberCell, DateCell, TimeCell } from 'components/DataTableTest'

export default ({ columns, groupBy, locales }) => {
	const cols = []
	const footerColsArr = []
	let customSummary
	columns.forEach((item, i) => {
		const { localFormat, children, ...col } = { ...item }
		if(!col.customizeText) {
			switch(localFormat?.type) {
				case 'date': col.customizeText = ({ value }) => DateCell({ locales })({ value })
					break
				case 'time': col.customizeText = ({ value }) => TimeCell({ locales })({ value })
					break
				// Precision is 2 by default
				case 'float': col.customizeText = ({ value }) => NumberCell({ locales, toFixed: localFormat?.precision >= 0 ? localFormat?.precision : 2, ...localFormat })({ value })
					break
				default:
			}
		}

		const groupIndex = Array.isArray(groupBy) && groupBy.indexOf(col.dataField)
		const colProps = {
			...(groupIndex === 0 || groupIndex > 0) && { groupIndex },
			...col
		}
		const colComp = (
			<Column key={`${col.dataField}-${i}`} {...colProps}>
				{typeof children === 'function' ? children() : null}
			</Column>
		)
		cols.push(colComp)
		const { customizeText, calculateCustomSummary, ...summary } = col?.summary || {}
		if(calculateCustomSummary) {
			customSummary = calculateCustomSummary
		}

		if(col.summary) {
			footerColsArr.push(
				<TotalItem
					key={i}
					column={col.dataField || col.caption}
					{...col.format && { valueFormat: col.format }}
					customizeText={customizeText || colProps.customizeText}
					{...summary}
				/>)
		}
		if(col.groupSummary) {
			footerColsArr.push(
				<GroupItem
					key={`${i}_group`}
					column={col.groupSummary.column === null ? null : (col.dataField || col.caption)}
					name={col.groupSummary.name || col.dataField || col.caption}
					{...col.format && { valueFormat: col.format }}
					customizeText={customizeText || colProps.customizeText}
					{...col.groupSummary}
				/>)
		}
	})
	const footerCols = footerColsArr.length
		? <Summary skipEmptyValues texts={{ sum: '' }} {...customSummary && { calculateCustomSummary: customSummary }}>{footerColsArr}</Summary>
		: null

	return {
		cols,
		footerCols
	}
}
